module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top-countdown"
  }, [_c('div-container', [_c('div', {
    staticClass: "block"
  }, [_c('span', {
    staticClass: "digit"
  }, [_vm._v(_vm._s(_vm._f("two_digits")(_vm.days)))]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("DAYS")])]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('span', {
    staticClass: "digit"
  }, [_vm._v(_vm._s(_vm._f("two_digits")(_vm.hours)))]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("HRS")])]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('span', {
    staticClass: "digit"
  }, [_vm._v(_vm._s(_vm._f("two_digits")(_vm.minutes)))]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("MINS")])]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('span', {
    staticClass: "digit"
  }, [_vm._v(_vm._s(_vm._f("two_digits")(_vm.seconds)))]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("SECS")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9ee8cfa2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/TopCountdown.vue
// module id = 926
// module chunks = 1